<template>
  <div class="card">
    <div class="card-header text-center py-2">{{ titulo }}</div>
    <div class="card-body" v-if="verForm">
      <form @submit.prevent="guardar">
        <div class="form-group row mb-1">
          <label for="inputNombre" class="col-sm-2 col-form-label">Nombre:</label>
          <div class="col-sm-4">
            <input
            type="text"
            v-model="form.nombre"
            class="form-control form-control-sm"
            :required="true"
            id="inputNombre"
            >
          </div>
          <label for="inputDireccion" class="col-sm-2 col-form-label">Dirección:</label>
          <div class="col-sm-4">
            <input
            type="text"
            v-model="form.direccion"
            class="form-control form-control-sm"
            id="inputDireccion"
            >
          </div>
        </div>
        <div class="form-group row mb-1">
          <label for="inputTelefono" class="col-sm-2 col-form-label">Teléfono:</label>
          <div class="col-sm-4">
            <input
            type="text"
            v-model="form.telefono"
            class="form-control form-control-sm"
            id="inputTelefono"
            >
          </div>
          <label for="inputCorreo" class="col-sm-2 col-form-label">Correo:</label>
          <div class="col-sm-4">
            <input
            type="text"
            v-model="form.correo"
            class="form-control form-control-sm"
            id="inputCorreo"
            >
          </div>
        </div>
        <div class="form-group row mb-1">
          <label for="textAreaBienvenida" class="col-sm-2 col-form-label">Bienvenida:</label>
          <div class="col-sm-10">
            <textarea 
            v-model="form.bienvenida"
            class="form-control form-control-sm"
            id="textAreaBienvenida"
            > 
            </textarea>
          </div>
        </div>
        <div class="form-group row mb-1">
          <div class="col-sm-12 text-right">
            <button
              type="button"
              class="btn btn-sm btn-secondary mr-1"
              v-if="reg !== ''"
              @click.prevent="limpiar"
            >
              Nuevo
            </button>
            <button type="submit" class="btn btn-sm btn-primary" :disabled="btnGuardar">
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
                v-if="btnGuardar"
              ></span>
              <span class="sr-only" v-if="btnGuardar">
                {{ reg === '' ? 'Guardando...':'Actualizando...' }}
              </span>
              <span v-if="!btnGuardar">
                {{ reg === '' ? 'Guardar':'Actualizar' }}
              </span>
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="card-footer text-muted p-1">
      <span v-if="inicio">Buscando...</span>
      <div class="input-group input-group-sm mb-0" v-else>
        <input 
          type="text" 
          class="form-control" 
          v-model="listaTermino"
          placeholder="Buscar por nombre" 
          aria-label="Buscar por nombre" 
          aria-describedby="btnBuscarNombre"
        >
        <div class="input-group-append">
          <button 
            class="btn btn-outline-secondary px-3" 
            type="button" 
            @click="verForm = !verForm"
            id="btnBuscarNombre"
          >
            <font-awesome-icon icon="angle-up" v-if="verForm"/>
            <font-awesome-icon icon="angle-down" v-else/>
          </button>
        </div>
      </div>
    </div>
    <div class="table-responsive" v-if="!inicio">
      <table class="table table-sm">
        <thead class="thead-light">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Nombre</th>
            <th scope="col">Dirección</th>
            <th scope="col">Teléfono</th>
            <th scope="col">Correo</th>
            <th scope="col">Bienvenida</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(i, idx) in filtrada" :key="i.id">
            <th scope="row">{{ idx + 1 }}</th>
            <td><a href="#" @click.prevent="editar(idx)">{{ i.nombre }}</a></td>
            <td>{{ i.direccion }}</td>
            <td>{{ i.telefono }}</td>
            <td>{{ i.correo }}</td>
            <td>{{ i.bienvenida }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import ManteAccion from '../mixins/ManteAccion.js';

export default {
  name: 'ManteCartaRestaurante',
  mixins: [ManteAccion],
  data: () => ({
    titulo: 'Restaurante'
  }),
  created () {
    this.nombre = 'restaurante';
    this.listaFiltrar = 'nombre';
  }
}
</script>